import { createFileRoute } from "@tanstack/react-router";

import EditScheduleForm from "../../-components/Purchase/Recurring/EditScheduleForm";

export const Route = createFileRoute("/_authenticated/trade/purchase/recurring/edit/$scheduleId")({
  component: EditScheduleForm,
  context: () => ({ permissions: "trade.purchase.recurring" }),
});
